/* ==========================================================================
   Statement Denim — product page

   Thumbnail switching between the 360° sequence and the stills, the size
   selector with live stock lines, and add-to-cart. The form posts normally
   without JavaScript; this upgrades it to stay on the page.
   ========================================================================== */
(function () {
  'use strict';

  var SD = window.SD || {};

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var pdp = document.querySelector('[data-sd-pdp]');
    if (!pdp) return;

    /* ── gallery ─────────────────────────────────────────────────────── */

    var stage = pdp.querySelector('[data-sd-stage]');
    var still = pdp.querySelector('[data-sd-still]');
    var deg = pdp.querySelector('[data-sd-deg]');
    var hint = pdp.querySelector('[data-sd-hint]');
    var badge = pdp.querySelector('[data-sd-badge]');
    var scrub = document.querySelector('.sd-pdp__scrub');
    var thumbs = [].slice.call(pdp.querySelectorAll('[data-sd-thumb]'));

    function selectThumb(thumb) {
      if (!thumb) return;
      thumb.click();
      /* the strip scrolls sideways, so the newly active cell may be off-screen */
      if (thumb.scrollIntoView) {
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var is360 = thumb.getAttribute('data-sd-thumb') === '360';

        thumbs.forEach(function (t) {
          var on = t === thumb;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        if (still) {
          if (!is360) {
            still.src = thumb.getAttribute('data-sd-still-src') || '';
            still.alt = thumb.getAttribute('data-sd-still-alt') || '';
          }
          still.hidden = is360;
        }

        /* drag, the degree readout and the drag cursor label all belong to the
           360 sequence only */
        if (stage) {
          if (stage.setEnabled) stage.setEnabled(is360);
          if (is360) stage.setAttribute('data-sd-cur', 'Drag');
          else stage.removeAttribute('data-sd-cur');
        }
        if (deg) deg.hidden = !is360;
        if (hint) hint.hidden = !is360;
        if (scrub) scrub.style.opacity = is360 ? '1' : '0.25';
        if (badge) badge.textContent = thumb.getAttribute('data-sd-badge-text') || '';
      });
    });

    /* ── paging the stage ────────────────────────────────────────────────
       The zones sit inside the stage, so on a turntable a press that travels is
       a rotation and a press that does not is a page turn. Tracked here rather
       than in the turntable so the two never fight over the same pointer.
       ──────────────────────────────────────────────────────────────────── */

    var stageEl = pdp.querySelector('[data-sd-stage]');
    var navs = [].slice.call(pdp.querySelectorAll('[data-sd-nav]'));

    if (stageEl && navs.length && thumbs.length > 1) {
      var pressX = null;
      var travelled = false;

      stageEl.addEventListener('pointerdown', function (e) {
        pressX = e.clientX;
        travelled = false;
      });

      stageEl.addEventListener('pointermove', function (e) {
        if (pressX !== null && Math.abs(e.clientX - pressX) > 5) travelled = true;
      });

      stageEl.addEventListener('pointerup', function () {
        pressX = null;
      });

      navs.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (travelled) return; /* that was a drag, not a page turn */

          var current = thumbs.findIndex(function (t) {
            return t.classList.contains('is-on');
          });
          if (current < 0) current = 0;

          var step = btn.getAttribute('data-sd-nav') === 'next' ? 1 : -1;
          var next = (current + step + thumbs.length) % thumbs.length;
          selectThumb(thumbs[next]);
        });
      });
    } else {
      /* one image, or none — the zones would do nothing, so take them out */
      navs.forEach(function (btn) {
        btn.remove();
      });
    }

    /* ── size selector ───────────────────────────────────────────────── */

    var sizes = [].slice.call(pdp.querySelectorAll('[data-sd-size]'));
    var stock = pdp.querySelector('[data-sd-stock]');
    var variantInput = pdp.querySelector('[data-sd-variant-input]');
    var addBtn = pdp.querySelector('[data-sd-add]');
    var optionLabel = (pdp.querySelector('.sd-pdp__sizeHead .sd-label') || {}).textContent || 'Size';
    var chosen = null;

    function variantFrom(btn) {
      return {
        id: +btn.getAttribute('data-sd-variant'),
        option: btn.getAttribute('data-sd-option'),
        title: btn.getAttribute('data-sd-option'),
        available: btn.getAttribute('data-sd-available') === 'true',
        tracked: btn.getAttribute('data-sd-tracked') === 'true',
        qty: +btn.getAttribute('data-sd-qty'),
      };
    }

    sizes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        sizes.forEach(function (o) {
          o.setAttribute('aria-pressed', o === btn ? 'true' : 'false');
        });

        chosen = variantFrom(btn);
        if (variantInput) variantInput.value = chosen.id;
        if (stock) {
          stock.textContent = SD.stockLine(chosen, optionLabel.trim());
          stock.classList.remove('is-warn');
        }
        if (addBtn) {
          addBtn.textContent = addBtn.getAttribute('data-sd-label') || addBtn.textContent;
          addBtn.classList.remove('is-added');
        }
      });
    });

    /* ── add to cart ─────────────────────────────────────────────────── */

    var form = pdp.querySelector('#sd-product-form');

    if (form && addBtn) {
      addBtn.setAttribute('data-sd-label', addBtn.textContent.trim());

      form.addEventListener('submit', function (e) {
        if (sizes.length && !chosen) {
          e.preventDefault();
          if (stock) {
            stock.textContent = 'Pick a ' + optionLabel.trim().toLowerCase() + ' first';
            stock.classList.add('is-warn');
          }
          return;
        }

        if (!window.fetch) return; /* let the form post normally */

        e.preventDefault();
        var id = variantInput ? +variantInput.value : null;
        if (!id) return;

        addBtn.disabled = true;

        SD.addToCart(id, 1)
          .then(function () {
            var suffix = chosen ? ' — ' + optionLabel.trim().toLowerCase() + ' ' + chosen.option : '';
            addBtn.textContent = 'Added' + suffix;
            addBtn.classList.add('is-added');
            addBtn.disabled = false;
          })
          .catch(function (err) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute('data-sd-label');
            if (stock) {
              stock.textContent = (err && err.description) || 'Could not add — try again';
              stock.classList.add('is-warn');
            }
          });
      });
    }

    /* ── save for later ──────────────────────────────────────────────── */

    var save = pdp.querySelector('[data-sd-save]');
    if (save) {
      var KEY = 'sd-saved';
      var handle = (location.pathname.split('/products/')[1] || '').split('?')[0];

      function read() {
        try {
          return JSON.parse(localStorage.getItem(KEY) || '[]');
        } catch (err) {
          return [];
        }
      }

      var saved = read();
      var label = save.textContent.trim();
      if (handle && saved.indexOf(handle) !== -1) save.textContent = 'Saved';

      save.addEventListener('click', function () {
        if (!handle) return;
        var list = read();
        var at = list.indexOf(handle);
        if (at === -1) {
          list.push(handle);
          save.textContent = 'Saved';
        } else {
          list.splice(at, 1);
          save.textContent = label;
        }
        try {
          localStorage.setItem(KEY, JSON.stringify(list));
        } catch (err) {
          /* private mode — the button just doesn't persist */
        }
      });
    }
  });
})();
